// Centralized PDF.js worker configuration.
//
// Import this module wherever react-pdf is used (it's idempotent - setting
// GlobalWorkerOptions.workerSrc more than once is harmless). It points PDF.js at
// our polyfilled worker bundle instead of the raw pdfjs-dist worker, so older
// browsers (e.g. Chrome 109) get the runtime-API shims in the worker thread.
//
// `?worker&url` tells Vite to bundle pdfWorker.js (polyfill + pdfjs worker) into a
// standalone worker file and hand back its URL. PDF.js then loads that URL as a
// module worker (`new Worker(url, { type: "module" })`), which is why vite.config
// sets `worker.format = "es"`.
import { pdfjs } from "react-pdf";
import pdfWorkerUrl from "./pdfWorker.js?worker&url";

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

export { pdfjs };
